export default __webpack_public_path__ + "static/media/auth-ilustration.5530d799.svg";